import React, { useState } from 'react';



import { FaPrint } from 'react-icons/fa';

import { Dots } from "react-activity";
import Popup from '../Popup';
import Input from '../Input';

function PopupReports(props) {
    const [selectedFields, setSelectedFields] = useState([]);
    const [generating, setGenerating] = useState(false);
    const [fileName, setFileName] = useState('');

    return (
        <Popup
            visibility={props.visibility}
            setVisibility={props.setVisibility}
            icon={<FaPrint />}
            tittle={props.tittle ? props.tittle : ""}
        >
            <form>
                <Input
                    label='Nome do documento'
                    placeholder="Escreva aqui o nome do arquivo"
                    onChange={(event) => setFileName(event.target.value)}
                    value={fileName}
                />
                <div className="checkbox-group">
                    <span className="tittle">Escolha os campos do relatório:</span>

                    <Input
                        checked={selectedFields.length === props.fields.length}
                        placeholder="Selecionar todos"
                        type='checkbox'
                        id="reports-select-all"
                        hideLabel
                        bold
                        onChange={(event) => {
                            if (event.target.checked)
                                setSelectedFields(props.fields.map((item) => item.field));
                            else
                                setSelectedFields([]);
                        }}
                    />

                    {
                        props.fields.map((item, index) =>
                            <Input
                                checked={selectedFields.includes(item.field)}
                                key={index}
                                placeholder={item.header}
                                type='checkbox'
                                id={`reports-${item.header.toLowerCase()}`}
                                hideLabel
                                bold
                                onChange={(event) => {
                                    let index = selectedFields.indexOf(event.target.value);
                                    if (index === -1)
                                        setSelectedFields([...selectedFields, event.target.value]);
                                    else
                                        setSelectedFields([...selectedFields.slice(0, index), ...selectedFields.slice(index + 1, selectedFields.length)]);
                                }}
                                value={item.field}
                            />
                        )
                    }
                </div>
                <button
                    type='button'
                    onClick={async () => {
                        if (generating) {
                            alert("O relatório já está sendo gerado, aguarde um momento.");
                        } else if (selectedFields.length > 0) {
                            setGenerating(true);
                            const flagReportGenerated = await props.generateReport(
                                props.fields
                                    .filter((item) => selectedFields.includes(item.field))
                                    .map((item) => item.field),
                                fileName
                            );
                            setGenerating(false);
                            if (flagReportGenerated) {
                                setSelectedFields([]);
                                props.setVisibility(false);
                            }
                        } else
                            alert("Selecione os campos a serem exibidos no relatório.");
                    }}
                >
                    {
                        generating ?
                            <Dots />
                            : "Gerar"
                    }
                </button>
            </form>
        </Popup>
    )
}

export default PopupReports;